<div [ngClass]="displayInvalidClass">
  <ng-content></ng-content>
  <ng-container *ngIf="qpointFormControl">
    <qpoint-validation-message [controlToValidate]="qpointFormControl" [isSubmitted]="isSubmitted"></qpoint-validation-message>
  </ng-container>
  <ng-container *ngIf="(showError$ | async) == true && hasErrors && formControls && !qpointFormControl">
    <qpoint-validation-message *ngFor="let control of formControls" [controlToValidate]="control.getControl()" [isSubmitted]="true"></qpoint-validation-message>
  </ng-container>
</div>
